export class BrandDTO {
    brandId?: number;
    name?: string;
}

export default class Brand extends BrandDTO{
    constructor(dto?: BrandDTO) {
        super();
        if(dto) {
            Object.assign(this, dto);
        }
    }
}

